// Must match BUSINESS_CATEGORIES in backend/server.py
export const BUSINESS_CATEGORIES = [
  'abbigliamento', 'bar', 'calzature', 'casa_ferramenta', 'centro_estetico',
  'gastronomia', 'gioielleria', 'libreria', 'animali', 'ottica', 'panetteria',
  'parrucchiere', 'pasticceria', 'pizzeria', 'ristorante', 'altro',
];
